import { integrationsApi } from '../api/misc';
import { easyParcelService } from '../services/EasyParcelService';

/**
 * Initialize EasyParcel service from database settings
 * Call this on app startup
 */
export const initializeEasyParcel = async () => {
    try {
        const row = await integrationsApi.get('easyparcel').catch(() => null);
        const settings = (row as any)?.settings;

        // Honor 'active' status if present in settings (default treat as active)
        const isActive = settings?.status ? settings.status === 'active' : true;

        if (settings && settings.api_key && isActive) {
            // Configure service
            easyParcelService.setApiKey(settings.api_key);
            easyParcelService.setMode(settings.test_mode ? 'test' : 'live');

            console.log(`[EasyParcel] Initialized in ${settings.test_mode ? 'TEST' : 'LIVE'} mode`);
            return true;
        }

        return false;
    } catch (err) {
        console.error('Failed to initialize EasyParcel:', err);
        return false;
    }
};
